export const emptyPortCostData = {
  id: 0,
  location_id: 0,
  assortment_id: 0,
  marcura_port_id: '',
  marcura_group_id: '',
  data: { costs: [] },
};
